import { useEffect, useState } from 'react';
import Base from '../../utils/base';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FormInput from '../../components/FormInput';
import AuthHeader from '../../components/AuthHeader';

export default function AuthForgetPass(){
    var base = new Base()

    const [forget_pass_form_arr, set_forget_pass_form_arr] = useState([{label : 'User name', input_type : 'text', type : 'username', value : '', is_error : false}])

    const [is_button_disable, set_is_button_disable] = useState(false)
    const [alert_data, set_alert_data] = useState({message : '', type : ''})

    useEffect(async ()=>{
        await localStorage.clear()
    }, [])

    async function changeInput(value, index){
        set_alert()
        set_is_button_disable(false)

        var data_index = forget_pass_form_arr[index]
        forget_pass_form_arr[index].value = value
        for(var x in forget_pass_form_arr){
            forget_pass_form_arr[x].is_error = false
        }
        base.update_array(forget_pass_form_arr, set_forget_pass_form_arr, data_index, index)
    }

    async function set_alert(message='', type=''){
        set_alert_data({message : message, type : type})
    }

    async function forgetPassSubmit(e){
        e.preventDefault()
        var flag = 1
        var data_form = {username : ''}

        for(var x in forget_pass_form_arr){
            if(forget_pass_form_arr[x].value === ''){
                forget_pass_form_arr[x].is_error = true
                base.update_array(forget_pass_form_arr, set_forget_pass_form_arr, forget_pass_form_arr[x], x)
                flag = 0
                break
            }
            else{
                data_form[forget_pass_form_arr[x].type] = forget_pass_form_arr[x].value
            }
        }
        
        if(flag){
            base.$('#preloader_modal').modal('show')
            set_is_button_disable(true)

            var url = '/auth/forget-password'
            var response = await base.request(url, 'post', data_form)
            if(response != null){
                if(response.status == 'success'){
                    await localStorage.setItem('token', response.token)

                    set_alert('Please check your email!', 'success')

                    setTimeout(() => {
                        window.location.href = '/'
                    }, 1000);
                }
                else{
                    set_alert(response.message, 'danger')
                    setTimeout(() => {
                        base.$('#preloader_modal').modal('hide')
                    }, 750);
                    set_is_button_disable(false)
                }
            }
            else{
                setTimeout(() => {
                    base.$('#preloader_modal').modal('hide')
                }, 750);
                set_is_button_disable(false)
            }
        }
    }


    return(

        <div className='page_wrap'>
            <div className='row m-0'>

                <div className='col-12'>
                <AuthHeader title={'Lupa Password'} is_back_btn={true} />
                </div>

                <div className='col-12 mt-5'>
                    <form className='row' onSubmit={(e)=>forgetPassSubmit(e)}>
                        {
                            alert_data.type != '' &&
                            <div className='col-12'>
                                <div class={"alert alert-" + (alert_data.type)} role="alert">
                                    {alert_data.message}
                                </div>
                            </div>
                        }

                        {
                            forget_pass_form_arr.map((data, index)=>(
                                <div className={"col-12 form-group m-0" + (index != 0 ? ' mt-3' : '')} key={index}>
                                    <FormInput
                                        label={data.label}
                                        type={data.type}
                                        value={data.value}
                                        changeInput={(value)=>changeInput(value, index)}
                                        is_error={data.is_error}
                                        error_message={(data.label) + ` can't be empty`} />
                                </div>
                            ))
                        }

                        <div className='col-12 mt-4'>
                            <button type='submit' className='btn btn-lg btn-primary w-100 shadow-sm rounded' onClick={(e)=>forgetPassSubmit(e)} disabled={is_button_disable}>Kirim Link</button>
                        </div>
                    </form>
                </div>


            </div>
        </div>
    )
}